import { render, staticRenderFns } from "./WysiwygTwoColumn.vue?vue&type=template&id=5faeb9a2&"
import script from "./WysiwygTwoColumn.vue?vue&type=script&lang=ts&"
export * from "./WysiwygTwoColumn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlockContentTwoColumns: require('/tmp/build_71ad00c4/src/components/block/ContentTwoColumns.vue').default})
